import React from 'react';
import PropTypes from 'prop-types';
import { Layout, Typography, theme } from 'antd';
import CommonFooter from '../footer/CommonFooter.component';
import PublicHeader from './common/PublicHeader';

const { Content } = Layout;
const { Title } = Typography;

const NonAuthLayout = ({ children, title }) => {
  const {
    token: { colorBgContainer },
  } = theme.useToken();

  return (
    <Layout style={{ minHeight: '100vh', background: colorBgContainer }}>
      <PublicHeader />
      <Content style={{
        minHeight: 'calc(100vh - 64px - 64px)',
        position: 'relative',
        background: colorBgContainer,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '40px 20px',
      }}>
        <div style={{
          maxWidth: '480px',
          width: '100%',
        }}>
          {title && (
            <Title level={2} style={{
              marginBottom: '24px',
              textAlign: 'center',
            }}>
              {title}
            </Title>
          )}
          {children}
        </div>
      </Content>
      <CommonFooter />
    </Layout>
  );
};

NonAuthLayout.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string,
};

export default NonAuthLayout;
